import {CarDetailsDynamic} from "../src/offer/detail/components/CarDetailsDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const RoutedOfferDetail = () => {
    return <CarDetailsDynamic />;
};

const config = [{reactDynamic: "offer", view: <RoutedOfferDetail />}];

(() => prepareHydratedApp(config))();
